import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  IDriverAsapBreakPostBody,
  IDriverBreakListQueryParams,
  IDriverBreakPatchBody,
  IDriverBreakResponse,
  IDriverScheduledBreakPostBody,
  Resources,
} from '../types'

export class DriverBreakResource extends GenericResource<
  IDriverBreakResponse,
  IDriverBreakListQueryParams,
  IDriverBreakPatchBody,
  IDriverScheduledBreakPostBody
> {
  public get = this.buildGet()
  public list = this.buildList()
  public post = this.buildPost()
  public patch = this.buildPatch()

  constructor(agent: IHttpAgent) {
    super(Resources.DriverBreaks, agent)
  }

  public async createAsap(body: IDriverAsapBreakPostBody): Promise<IDriverBreakResponse> {
    const res = await this.agent.post<IDriverBreakResponse>(Resources.DriverBreaksAsap, body)
    return res.data
  }

  public async cancel(driverBreakId: string): Promise<IDriverBreakResponse> {
    const res = await this.agent.post<IDriverBreakResponse>(`${Resources.DriverBreaks}/${driverBreakId}/cancellation`)
    return res.data
  }
}
